
export default function Evidence() {
  const specs = [
    {
      icon: 'ri-shield-star-line',
      title: '日本初',
      subtitle: (
        <>
          <span className="evidence-subtitle-pc">総務省消防庁 消火性能試験</span>
          <span className="evidence-subtitle-mobile">総務省消防庁<br />消火性能試験</span>
        </>
      ),
      description: '5項目全てに合格',
      detail: '特に「電気火災」対応。通電中の制御盤や配線火災も感電リスクなく消火可能。',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
    },
    {
      icon: 'ri-global-line',
      title: '世界基準',
      subtitle: (
        <>
          <span>SGS認証</span>
        </>
      ),
      description: (
        <>
          <span className="evidence-heat-pc">90℃耐熱テストクリア</span>
          <span className="evidence-heat-mobile" style={{ whiteSpace: 'nowrap', fontSize: '0.85rem' }}>90℃耐熱テストクリア</span>
        </>
      ),
      detail:
        'ボイラー室、夏場の倉庫、炉の近く。従来のスプレー(40℃制限)が置けなかった高温エリアにも常備可能。',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      icon: 'ri-trophy-line',
      title: '実績',
      subtitle: (
        <>
          <span>台湾シェアNo.1</span>
        </>
      ),
      description: 'プロ仕様の信頼性',
      detail:
        '台湾で最も選ばれているプロ仕様。',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="evidence-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ lineHeight: '1.5' }}>
            <span className="evidence-line1">数値と実績で証明する</span>
            <br />
            確かな性能
          </h2>
        </div>

        <div className="mb-16">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="aspect-video w-full">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/q1CwsixIuy8?start=43"
                title="FIRE OUT 消火性能デモンストレーション"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <div className="p-8 bg-gradient-to-r from-red-50 to-orange-50">
              <p className="evidence-video-label text-center text-lg font-semibold text-gray-900">
                実際の消火性能をご確認ください
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {specs.map((spec, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className={`${spec.bgColor} rounded-2xl p-6 mb-6`}>
                <div className="flex items-center justify-center mb-4">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-md">
                    <i className={`${spec.icon} text-4xl ${spec.color}`}></i>
                  </div>
                </div>
                <div className="text-center">
                  <p className={`text-sm font-bold ${spec.color} mb-2`}>{spec.title}</p>
                  <p className="text-lg font-bold text-gray-900 mb-2">{spec.subtitle}</p>
                  <p className={`evidence-spec-desc text-xl font-bold ${spec.color}`}>{spec.description}</p>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{spec.detail}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-green-50 to-teal-50 rounded-2xl p-10 text-center">
          <div className="flex items-center justify-center space-x-4 mb-6">
            <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center">
              <i className="ri-checkbox-circle-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900">
              <span className="evidence-clear-pc">全ての基準をクリア</span>
              <span className="evidence-clear-mobile">すべての基準を<br />クリア</span>
            </h3>
          </div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            日本の消防基準、世界の安全基準、そして実際の産業現場での実績。
            <br />
            FIRE OUTは、あらゆる角度から検証された信頼の消火具です。
          </p>
          <p className="text-sm text-gray-500 max-w-3xl mx-auto mt-4">
            ※エアゾール式簡易消火具は、消火器の代替品としてではなく、補助的な役割としてその効果が期待されるものです。
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .evidence-heading {
            font-size: 1.5rem !important;
            line-height: 1.6 !important;
          }
          .evidence-line1 {
            white-space: nowrap;
          }
          .evidence-video-label {
            font-size: 0.85rem !important;
            white-space: nowrap;
          }
          .evidence-subtitle-pc {
            display: none;
          }
          .evidence-subtitle-mobile {
            display: inline;
          }
          .evidence-clear-pc {
            display: none;
          }
          .evidence-clear-mobile {
            display: inline;
          }
          .evidence-heat-pc {
            display: none;
          }
          .evidence-heat-mobile {
            display: inline !important;
            font-size: 0.85rem !important;
            white-space: nowrap;
          }
          .evidence-spec-desc {
            font-size: 0.9rem !important;
          }
        }
        @media (min-width: 769px) {
          .evidence-subtitle-pc {
            display: inline;
          }
          .evidence-subtitle-mobile {
            display: none;
          }
          .evidence-clear-pc {
            display: inline;
          }
          .evidence-clear-mobile {
            display: none;
          }
          .evidence-heat-pc {
            display: inline;
          }
          .evidence-heat-mobile {
            display: none;
          }
        }
      `}</style>
    </section>
  );
}